import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DraggableIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Draggable`} {...props}>
    <Path
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 5v6M8 5v6M12 5v6"
    />
  </Icon>
);
